// Skip already-expired WhatsApp profile-picture URLs so the browser never
// fires a 403 for a link that's past its signed expiry. WhatsApp CDN URLs
// (pps.whatsapp.net) carry an `oe=` param — a hex Unix-seconds expiry. If it's
// in the past the image is guaranteed to 403, so we return undefined and let
// the <Avatar> fall back to initials without a failed network request. Valid
// (non-expired, or non-WhatsApp) URLs pass through unchanged.
export default function avatarSrc(url) {
  if (!url || typeof url !== "string") return undefined;
  try {
    const m = /[?&]oe=([0-9a-fA-F]+)/.exec(url);
    if (m) {
      const expSec = parseInt(m[1], 16);
      if (expSec && expSec * 1000 < Date.now()) return undefined;
    }
  } catch (e) {
    /* malformed URL — just use it as-is */
  }
  return url;
}
